// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.customDatePickerWidth, 
.customDatePickerWidth > div.react-datepicker-wrapper, 
.customDatePickerWidth > div > div.react-datepicker__input-container
.customDatePickerWidth > div > div.react-datepicker__input-container input {
   width: 120%;
}`, "",{"version":3,"sources":["webpack://./src/Components/component-styles.css"],"names":[],"mappings":"AAAA;;;;GAIG,WAAW;AACd","sourcesContent":[".customDatePickerWidth, \n.customDatePickerWidth > div.react-datepicker-wrapper, \n.customDatePickerWidth > div > div.react-datepicker__input-container\n.customDatePickerWidth > div > div.react-datepicker__input-container input {\n   width: 120%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
